import React from 'react';

const Contact = () => {
  return (
    <div className="page-container">
      <h1>Contact Us</h1>
      <p>
        Have a question, feedback, or a partnership inquiry? We'd love to hear from you!
      </p>
      <p>
        For instant queries or deal suggestions, reach out to us via our community Telegram channel:{' '}
        <a href="https://t.me/updealzz" target="_blank" rel="noopener noreferrer">
          @updealzz
        </a>.
      </p>
      <p>
        You can also email us directly at{' '}
        <a href="mailto:support@updeals.in">support@updeals.in</a>.
      </p>
    </div>
  );
};

export default Contact;
